<career-content-list *ngIf="!hasJobId"></career-content-list>
<career-content-detail
  *ngIf="hasJobId && jobId"
  [jobId]="jobId"
></career-content-detail>
